import React from "react";
import Chart from "react-apexcharts";
import { Card, Typography, IconButton } from "@mui/material";
import { CircleArrowOutUpRight } from "lucide-react";

const TaskColumnChart = ({ data = [] }) => {
  // Format data from API
  const formatChartData = () => {
    if (!data || data.length === 0) {
      return {
        categories: [],
        taskCounts: [],
      };
    }

    // Sort data by year and month number
    const sortedData = [...data].sort((a, b) => {
      if (a.year !== b.year) {
        return a.year - b.year;
      }
      return a.monthNumber - b.monthNumber;
    });

    const categories = sortedData.map((item) => item.month);
    const taskCounts = sortedData.map((item) => item.totalTasks);

    return { categories, taskCounts };
  };

  const { categories, taskCounts } = formatChartData();

  const series = [
    {
      name: "Total Tasks",
      data: taskCounts,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "60%",
        borderRadius: 4,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    colors: ["#4CAF50"],
    xaxis: {
      categories: categories,
      labels: {
        rotate: -45,
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      decimalsInFloat: 0,
      title: {
        text: "Number of Tasks",
        style: {
          fontSize: "14px",
          fontWeight: 600,
        },
      },
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    grid: {
      show: true,
      borderColor: "#f1f1f1",
      strokeDashArray: 3,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " tasks";
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.1,
        gradientToColors: ["#2E7D32"],
        inverseColors: false,
        opacityFrom: 0.8,
        opacityTo: 1,
      },
    },
  };

  return (
    <Card
      sx={{
        color: "#000",
        minHeight: 400,
        p: 2,
        boxShadow: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          padding: "2px 10px",
          justifyContent: "space-between",
          marginBottom: 2,
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontSize={16} fontWeight={600}>
          Monthly Task Summary
        </Typography>
      </div>

      <Chart options={options} series={series} type="bar" height={350} />
    </Card>
  );
};

export default TaskColumnChart;
